// extracted by mini-css-extract-plugin
export default {"heartFromWishlist":"HeartFromWishlist_heartFromWishlist__AlMV3"};